<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="issueCloseRateEchart"></div>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="最近一年问题关闭率，按问题创建时间查询，按月份分组显示。" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "lpa-center",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dataList: this.beans,
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("issueCloseRateEchart")
      );

      var data = this.dataList;

      const xAxis = [];
      const lineData = [];
      const barData = [];
      const closedCount = [];
      const unCount = [];
      const expiredCount = [];
      let periodText = "";
      data.forEach((item) => {
        switch (item.period) {
          case "year":
            periodText = "年";
            break;
          case "month":
            periodText = "月";
            break;
          case "day":
            periodText = "日";
        }
        this.tableTitle = periodText;
        xAxis.push(item.periodValue + periodText);
        lineData.push(item.issueCount);
        closedCount.push(item.closedCount);
        unCount.push(item.issueCount - item.closedCount - item.uclosedCount);
        expiredCount.push(item.uclosedCount);
        if (item.issueCount == 0) {
          barData.push(0);
        } else {
          barData.push(
            parseInt((item.closedCount / item.issueCount) * 100 + "", 0)
          );
        }
      });

      var option = {
        title: {
          text: "月度问题关闭率",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: "24",
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["期限内未关闭", "逾期未关闭", "已关闭", "关闭率"],
          right: 5,
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: 14,
          },
          itemGap: 2,
        },
        grid: {
          left: "10",
          right: "0",
          bottom: "0",
          top: 75,
          y2: 40,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              interval: 0,
              //     rotate: 25,
            },
          },
        ],
        yAxis: [
          {
            nameTextStyle: {
              fontSize: 14,
            },
            type: "value",
            name: "问题数",
            min: 0,

            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            nameTextStyle: {
              fontSize: 14,
            },
            type: "value",
            name: "关闭率",
            min: 0,

            axisLabel: {
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            color: ["#00CD66"],
            name: "已关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "100%",
            data: closedCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 14,
                  },
                },
              },
            },
          },
          {
            color: ["#FFcc99"],
            name: "期限内未关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "50%",
            data: unCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
          },
          {
            color: ["red"],
            name: "逾期未关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "100%",
            data: expiredCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
          },
          {
            color: ["#00CD66"],
            name: "关闭率",
            type: "line",
            yAxisIndex: 1,
            data: barData,
            itemStyle: {
              normal: {
                //改变折线点的颜色
                lineStyle: {
                  color: "#00CD66", //改变折线颜色
                  fontSize: 14,
                },
              },
            },
          },
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.startCharts) {
        clearInterval(this.startCharts);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.startCharts = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= data.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/ehs/component/issue-closed-rate.vue